import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Switch,
  FormControlLabel,
  TextField,
  Box,
} from "@mui/material";
import useCheesecakeFormData from "../../../../hooks/useCheesecakeFormData";
import GeneralInfoSection from "./GeneralInfoSection";
import IngredientSelectSection from "./IngredientSelectSection";
import TagSelectSection from "./TagSelectSection";
import ImageUploadSection from "./ImageUploadSection";
import PopularitySelectSection from "./PopularitySelectSection";

const CheesecakeFormModal = ({ onClose, onSave, cheesecake }) => {
  const {
    formData,
    setFormData,
    formErrors,
    primaryPreview,
    secondaryPreviews,
    handlePrimaryImageChange,
    handleSecondaryImagesChange,
    handleSubmit,
    uploading,
    sizeOptions,
    ingredientsOptions,
    loadingIngredients,
    allergenOptions,
    dietaryOptions,
  } = useCheesecakeFormData(cheesecake, onClose, onSave);

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {cheesecake ? "Edit Cheesecake" : "Add New Cheesecake"}
      </DialogTitle>

      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <GeneralInfoSection
          formData={formData}
          setFormData={setFormData}
          sizeOptions={sizeOptions}
          formErrors={formErrors}
        />

        <IngredientSelectSection
          ingredients={formData.ingredients}
          setIngredients={(newValue) =>
            setFormData({ ...formData, ingredients: newValue })
          }
          ingredientOptions={ingredientsOptions}
          loadingIngredients={loadingIngredients}
          formErrors={formErrors}
        />

        <TagSelectSection
          formData={formData}
          setFormData={setFormData}
          allergenOptions={allergenOptions}
          dietaryOptions={dietaryOptions}
          formErrors={formErrors}
        />

        <PopularitySelectSection
          formData={formData}
          setFormData={setFormData}
        />

        <ImageUploadSection
          primaryPreview={primaryPreview}
          secondaryPreviews={secondaryPreviews}
          handlePrimaryImageChange={handlePrimaryImageChange}
          handleSecondaryImagesChange={handleSecondaryImagesChange}
          formErrors={formErrors}
        />

        <Box sx={{ display: "flex", gap: 4, alignItems: "center", mt: 1 }}>
          <FormControlLabel
            control={
              <Switch
                checked={formData.isActive}
                onChange={(e) =>
                  setFormData({ ...formData, isActive: e.target.checked })
                }
              />
            }
            label="Visible to Customers"
          />

          <FormControlLabel
            control={
              <Switch
                checked={formData.isAvailable}
                onChange={(e) =>
                  setFormData({ ...formData, isAvailable: e.target.checked })
                }
              />
            }
            label="Available for Ordering"
          />
        </Box>

        {/* NEW: Internal Notes */}
        <TextField
          label="Admin Notes"
          multiline
          minRows={2}
          value={formData.notes}
          onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
          fullWidth
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit} disabled={uploading}>
          {uploading ? "Uploading..." : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CheesecakeFormModal;
